import { scrollToTop } from '@common/utils/scroll'
import { useEffect } from 'react'

export const useScrollToTop = () => {
    useEffect(() => {
        scrollToTop()
    }, [])
}
